import { useMutation } from "react-query";
import { message } from "antd";

import { axiosInstance } from "../../../../utils/axiosInstance";
import { queryClient } from "../../../../services/queryClient";

export const useDeleteDisplayPicture = () => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useMutation(
    ({ email }: { email: string }) =>
      axiosInstance
        .delete("tutors/profile-picture", {
          data: { email },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    {
      onSuccess: (data) => {
        message.success(data?.message);
        queryClient.invalidateQueries("gettutor");
      },
      onError: (error: any) => {
        message.error(error?.response?.data?.message);
      },
    }
  );
};
